import { Button, Stack, Typography } from '@mui/material'
import { useRouter } from 'next/router'
import Dialog from 'src/commons/components/Dialog'
import { DEEPLINK_URL } from 'constants/index'
import useLocales from 'hooks/useLocales'
import StateImage from 'components/state-image'

export function PhoneVerificationModal({ open, openDialog }) {
  const { t } = useLocales()
  const { push } = useRouter()

  return (
    <Dialog
      open={open}
      header={<></>}
      PaperProps={{ sx: { maxWidth: '500px' } }}
      body={
        // component="span" throughout: AlertDialog renders `body` inside a
        // DialogContentText (<p>), so a <div> (Stack), an <h5>, or a nested <p>
        // (body2) there is invalid nesting — the browser force-closes the
        // paragraph and hoists them out, which breaks the layout. StateImage is
        // an <img> and is already legal, so it needs no wrapper.
        <Stack
          component="span"
          alignItems="center"
          spacing={2}
          sx={{ display: 'flex' }}
        >
          <StateImage
            illustrationName="illustration_phone_verification"
            type="illustration"
          />
          <Typography
            variant="h5"
            component="span"
            sx={(theme) => ({
              display: 'block',
              color: theme.palette.grey['800'],
            })}
          >
            {t('key_mobile_number_not_added')}
          </Typography>
          <Typography
            variant="body2"
            component="span"
            sx={(theme) => ({
              display: 'block',
              textAlign: 'center',
              color: theme.palette.grey['800'],
            })}
          >
            {t('key_phone_verification_desc')}
          </Typography>
        </Stack>
      }
      footer={
        <Stack
          spacing={1}
          sx={{
            padding: '0px 24px 24px 24px',
          }}
        >
          <Button
            id="b-users-phoneverificationmodal-add-mobile-number"
            variant="contained"
            size="large"
            fullWidth
            onClick={() => push(`${DEEPLINK_URL}/verifyphonenumber`)}
          >
            {t('key_add_mobile_number')}
          </Button>
          <Button
            id="b-users-phoneverificationmodal-cancel"
            variant="outlined"
            size="large"
            fullWidth
            onClick={() => openDialog(false)}
            sx={{ border: 'none' }}
          >
            {t('key_cancel')}
          </Button>
        </Stack>
      }
      onClose={() => openDialog(false)}
    />
  )
}
